import React from 'react';
import { education } from '../data/education';
export function EducationList() {
  return <section className="bg-offwhite py-16 lg:py-24" data-id="element-41" data-mp="3r3o6yguo9rj8">
      <div className="mx-auto max-w-shell px-6 lg:px-8" data-id="element-42" data-mp="3r4z9yegamv9a">
        <ul className="flex flex-col gap-px bg-mist" data-id="element-43" data-mp="9mxw15fm8s9c">
          {education.map(entry => <li key={`${entry.institution}-${entry.degree}`} className="bg-white" data-id="element-44" data-mp="4vo9weta0727">
              <article className="grid gap-6 p-8 sm:grid-cols-[72px_1fr] lg:gap-10 lg:p-10" data-id="element-45" data-mp="in2v8sanokcf">
                <img src={entry.logo} alt={`${entry.institution} emblem`} className="h-16 w-16 border border-mist bg-white object-contain p-1" loading="lazy" data-id="element-46" data-mp="em146yqw7elj" />
                <div data-id="element-47" data-mp="nmyz8rjcsbrz">
                  <h2 className="font-serif text-2xl leading-snug text-navy" data-id="element-48" data-mp="nkcqwpon1s8p">
                    {entry.institution}
                  </h2>
                  <p className="mt-1 text-sm font-semibold text-gold-deep" data-id="element-49" data-mp="2pec095i79zir">
                    {entry.degree}
                  </p>
                  <div className="mt-5 border-t border-mist pt-5" data-id="element-50" data-mp="g76f6yo1kin5">
                    <p className="text-[11px] font-semibold uppercase tracking-overline text-slate-400" data-id="element-51" data-mp="l3wtphk7766g">
                      Activities and societies
                    </p>
                    <p className="mt-2 max-w-3xl text-sm leading-relaxed text-charcoal" data-id="element-52" data-mp="tx03nfvmx0wc">
                      {entry.activities}
                    </p>
                  </div>
                  {entry.detail && <p className="mt-5 max-w-3xl border-l-2 border-gold pl-5 text-sm leading-relaxed text-charcoal" data-id="element-53" data-mp="13uo9p1yoxutt">
                      {entry.detail}
                    </p>}
                </div>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}